module.exports = "data:image/gif;base64,R0lGODlhAQC0ALMMAN/f34yMjNTU1JGRkcPDw9ra2peXl7q6urGxsaioqJ+fn8zMzAAAAAAAAAAAAAAAACH5BAEAAAwALAAAAAABALQAAAQvEBSxyEFJmcG678FgKAlyEItQSJSFadwnz3RNh2N5pgV9ZbUcwib7KYjIpExIiwAAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/Default/slider-h.gif
// module id = 1649
// module chunks = 28